import request from '../utils/request';
const BASE_URL = '/api/v1/admin/manufacturer-shipping-rates/';
export function fetchManufacturerShippingRates(filters) {
    const params = new URLSearchParams();
    const search = filters?.search?.trim();
    const isActive = filters?.is_active;
    if (search)
        params.append('search', search);
    if (isActive !== undefined)
        params.append('is_active', String(isActive));
    if (filters?.ordering)
        params.append('ordering', filters.ordering);
    const queryString = params.toString();
    const url = queryString ? `${BASE_URL}?${queryString}` : BASE_URL;
    return request().get(url).send();
}
export function createManufacturerShippingRate(payload) {
    return request().post(BASE_URL).send(payload);
}
export function updateManufacturerShippingRate(id, payload) {
    return request().patch(`${BASE_URL}${id}/`).send(payload);
}
export function deleteManufacturerShippingRate(id) {
    return request().delete(`${BASE_URL}${id}/`).send();
}
export function fetchAvailableManufacturers() {
    return request().get(`${BASE_URL}available-manufacturers/`).send();
}
